module.exports = __webpack_public_path__ + "img/no-data-tint.b20a6b24.png";